import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginBottom: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  },
  tab: {
    textTransform: 'uppercase',
    fontSize: 12,
    color: theme.colorPalette.green_90_op_80,
    fontWeight: 'bold!important',
    display: 'flex',
    flexDirection: 'row',
    padding: 0,
    minWidth: 25,
    borderBottom: `${theme.colorPalette.orange_50} 1px solid`
  }
}));

export default useStyles;
